import { Campaign } from '@givebutter/types';
import { client } from 'client';

interface FetchLiveDisplayCampaignParams {
  campaignSlug: string;
}

const fetchLiveDisplayCampaign = ({ campaignSlug }: FetchLiveDisplayCampaignParams) => {
  return client
    .get<Campaign>(`/api-livedisplay/campaigns/${campaignSlug}`)
    .then(response => response.data);
};

export type { FetchLiveDisplayCampaignParams };
export { fetchLiveDisplayCampaign };
